import Bonus from './index';

export default {
    path: '/home/bonus',
    component: Bonus,
    children: []
}